export default "__VITE_ASSET__0wy9fM20__"